<template>
  <footer class="flex flex-col items-center justify-center space-y-1 py-8 text-sm font-bold text-gray-200 dark:text-gray-400 sm:flex-row sm:space-y-0 sm:space-x-2">
    <slot></slot>
  </footer>
</template>
